import type { MtAnimalsBreederGetAnimalsQuery } from '@gql/graphql';
import type { MtCardItemAnimalData } from '@presentation/components';
import { PLACEHOLDER_IMAGE_DOG } from '@presentation/constants';
import dayjs from 'dayjs';
import type { MouseEvent } from 'react';
import { useMemo } from 'react';

export const useFormatAnimals = ({
  animals = [],
  onClick,
}: {
  animals?: NonNullable<MtAnimalsBreederGetAnimalsQuery['accountMe']>['animals'];
  onClick?: (event: MouseEvent, index: number) => void;
}) => {
  const formattedAnimals: MtCardItemAnimalData[] = useMemo(() => {
    return animals.map(
      (animal, index) =>
        ({
          image: animal.imgs?.[0]?.small ?? PLACEHOLDER_IMAGE_DOG,
          name: animal.name,
          gender: animal.gender,
          archived: !!animal.archived,
          birthday: animal.birthday ? dayjs(animal.birthday) : undefined,
          availableForBreeding: animal.studInfos?.availableForBreeding,
          onClick: (event) => onClick?.(event, index),
        } as MtCardItemAnimalData),
    );
  }, [animals, onClick]);

  return { formattedAnimals };
};
